import { FlowChartBlock, FlowChartBlockType } from './FlowChartBlock'

export enum FlowChartDelayType {
  WAITING = 'waiting',
  TYPING = 'typing',
}

export interface FlowChartDelayBlock extends FlowChartBlock {
  type: FlowChartBlockType.DELAY
  data: {
    delay: number
    delayType: FlowChartDelayType
  }
}
